import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Get Rid Of <span className="hero-highlight">Septic</span> Headaches
          </h1>
          <p className="hero-description">
            Say goodbye to septic troubles with our reliable septic tank solutions. Experience hassle-free 
            maintenance and peace of mind knowing your septic system is in expert hands. Get rid of the stress 
            and eliminate septic headaches with All Around Septic Pumping, LLC.
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="hero-button primary">Request Service</Link>
            <a href="tel:903-218-8281" className="hero-button secondary">
              <span className="button-icon">📞</span>
              903-218-8281
            </a>
          </div>
        </div>
      </div>

      {/* Truck Image Section */}
      <div className="truck-section">
        <div className="truck-container">
          <img src="/AASP_Trunk.jpg" alt="All Around Septic Pumping Company Truck" className="truck-image" />
        </div>
      </div>

      {/* Features Section */}
      <div className="content-section">
        <div className="section-header">
          <h2>Why Choose All Around Septic Pumping?</h2>
          <p>Professional septic services you can trust, available 24/7/365</p>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⚙️</div>
            <h3>Expert Service</h3>
            <p>Years of experience in septic system maintenance and pumping. Our skilled technicians know how to handle any septic issue efficiently and professionally.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🕐</div>
            <h3>24/7 Emergency Service</h3>
            <p>Available around the clock for emergency calls. When you have a septic emergency, we're here to help, day or night, 365 days a year.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Competitive Pricing</h3>
            <p>Fair and transparent pricing that fits your budget. We provide quality service at competitive rates without compromising on excellence.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">✅</div>
            <h3>Reliable & Professional</h3>
            <p>Dependable service when you need it most. We're committed to providing exceptional customer service and keeping your septic system running smoothly.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎖️</div>
            <h3>First Responder & Military Discount</h3>
            <p>We honor those who serve our community and country. First responders and military personnel receive special discounts on our services as a token of our appreciation.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💧</div>
            <h3>Comprehensive Solutions</h3>
            <p>From pumping and maintenance to rentals and enzyme treatments, we offer complete septic system solutions for all your needs.</p>
          </div>
        </div>
      </div>

      {/* Services Preview Section */}
      <div className="services-preview-section">
        <div className="content-section">
          <div className="section-header">
            <h2>Our Services</h2>
            <p>Complete septic system solutions for residential and commercial properties</p>
          </div>
          <div className="services-preview-grid">
            <div className="service-preview-card">
              <h3>Septic Tank Pumping</h3>
              <p>Regular pumping to maintain your septic system's efficiency and prevent costly repairs.</p>
              <Link to="/services" className="service-link">Learn More →</Link>
            </div>
            <div className="service-preview-card">
              <h3>Equipment Rentals</h3>
              <p>Portable toilets available for your projects and events.</p>
              <Link to="/rentals" className="service-link">Learn More →</Link>
            </div>
            <div className="service-preview-card">
              <h3>Enzyme Treatments</h3>
              <p>Natural enzyme solutions to improve your septic system's performance and reduce odors.</p>
              <Link to="/enzymes" className="service-link">Learn More →</Link>
            </div>
          </div>
          <div className="cta-section">
            <h2>Need Septic Service?</h2>
            <p>Contact us today for reliable, professional septic services available 24/7</p>
            <Link to="/contact" className="cta-button">Get in Touch</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

